import z from "zod";

export enum RelationshipToSubscriber {
  SELF = "Self",
  SPOUSE = "Spouse",
  CHILD = "Child",
  OTHER = "Other",
}

export const relationshipToSubscriberSchema = z.nativeEnum(RelationshipToSubscriber);

export function parseRelationshipToSubscriber(value: string | null | undefined): RelationshipToSubscriber | null {
  const normalized = value?.trim().toLowerCase();

  if (!normalized) return null;

  if (normalized.includes("spouse")) return RelationshipToSubscriber.SPOUSE;
  if (normalized.includes("child")) return RelationshipToSubscriber.CHILD;
  if (normalized === RelationshipToSubscriber.SELF.toLowerCase()) return RelationshipToSubscriber.SELF;

  return RelationshipToSubscriber.OTHER;
}
